module.exports = __webpack_public_path__ + "static/media/logo_harinaselizondo.7e8ee57a.png";